module.exports = __webpack_public_path__ + "static/media/setting.2c5b928a.svg";